export enum BrandFeatures {
	Uncategorized = 'Uncategorized',
	Income = 'Income',
	Expenses = 'Expenses',
}
